// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"631":"12ff5d5b","836":"aa169f02"}[chunkId] + ".chunk.js";
};